import { render } from "./OTPBlackBox.vue?vue&type=template&id=5f98aba0"
import script from "./OTPBlackBox.vue?vue&type=script&lang=js"
export * from "./OTPBlackBox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__